export default "__VITE_ASSET__BzEI3do1__"